import {
  AppMultiSelect,
  AppRemixIcon,
  AppSingleSelect,
} from '@/layout/AppComponents';
import errorHandler from '@/layout/components/error/ErrorHandler';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { axiosPath } from '../../../../routing/helpers/router';
import Translator from '../../helpers/Translator';
import useIsMounted from '../../hooks/useIsMounted';

export default function ResponsibleSelect(props) {
  const {
    value,
    error,
    onHandleChange,
    ggclPlantHex,
    className = 'mb-2',
    title = '',
    isMulti = true,
    hasSearchBox = false,
    hasSelectOptions = false,
    isClearable = false,
    hasNoResponsibleOption = false,
    onlyWithPlantAccess = false,
    apiCall = '',
    required = false,
  } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [responsibles, setResponsibles] = useState();

  // > LOAD RESPONSIBLES //
  const loadResponsibles = useCallback(
    async () =>
      axios
        .post(axiosPath(apiCall), {
          moduleBridgeHex,
          plantHex: ggclPlantHex ?? plantHex,
          onlyWithPlantAccess,
        })
        .then(({ data }) => {
          if (isMounted.current) {
            setResponsibles(
              hasNoResponsibleOption
                ? [data.hasNoResponsibleOption, ...(data.responsibles || [])]
                : data.responsibles || []
            );
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, plantHex, ggclPlantHex, onlyWithPlantAccess]
  );

  useEffect(() => {
    loadResponsibles();
  }, []);
  // < LOAD RESPONSIBLES //

  return isMulti ? (
    <AppMultiSelect
      options={responsibles}
      title={
        title ||
        ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="responsibles" />
        )
      }
      placeholder={ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="select.one.or.multiple.responsibles"
        />
      )}
      value={value}
      error={error}
      onChange={(opt) => onHandleChange(opt)}
      icon={<AppRemixIcon icon="group" />}
      isLoading={!responsibles}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
      isClearable={isClearable}
      required={required}
    />
  ) : (
    <AppSingleSelect
      options={responsibles}
      title={
        title ||
        ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="responsible" />
        )
      }
      placeholder={ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="select.one.or.multiple.responsibles"
        />
      )}
      value={value}
      error={error}
      onChange={(opt) => onHandleChange(opt)}
      icon={<AppRemixIcon icon="user" />}
      isLoading={!responsibles}
      hasSearchBox={hasSearchBox}
      isClearable={isClearable}
      required={required}
    />
  );
}
